// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3UGix","title":"AfterFrontImage_title__18JTX"};